<!--
 * @Author: huboyi
 * @Date: 2022-03-21 10:44:20
 * @LastEditors: huboyi
 * @LastEditTime: 2022-03-28 19:56:39
 * @Description:
-->
<template>
  <div id="app">

    <router-view />

  </div>
</template>

<script>
import { saveLogInfo } from "@/service/postData";
import moment from "moment";
export default {
  name: "App",
  mounted() {
    //事件总线统一处理日志模板
    // this.$bus.$on("sendLog", (data)=>{
    //   let date = new Date();
    //   let operDate = moment(date).format('YYYY年MM月DD日HH时mm分');
    //   let userid = this.$store.state.user.userName || localStorage.getItem('userName');
    //   saveLogInfo({rs:'成功', type: data['type'], userid, content: `${operDate}${data['content']}`});
    // });

    // scale();
  },
  methods: {
    test() {
      // console.log("测试")
    }
  },
  watch: {
    $route(to, from) {
      this.$bus.$emit("routeChange", to.fullPath)
      this.$bus.$emit("urlChange")
    }
  }
};
</script>

<style>
/* 定义全局的css变量 */
:root {
  /* 背景色 */
  --theme_bg_color: #070628;
  /* 文字颜色 */
  --theme_font_color: #FFF;
  /* 每块标题颜色 */
  --theme_title_bg_color: #0A51A4;
  --theme_title_font_color: #03204B;
  --theme_panel_bg_color: #03204B;
  --theme_panel_border_color: #4DADFF;
  --theme_table_bg_color: #448ACA;
  /* 排名列表颜色 */
  --theme_ranking_color: #4cc4fd;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 1920px;
  height: 969px;
  overflow: hidden;
}

span {
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/App.vue